let imgPath = (process.env.REACT_APP_ENV ==='qa' || process.env.REACT_APP_ENV ==='dev') ? "https://d1z72rr1bj4jw1.cloudfront.net" : "https://d21itqh87zixpv.cloudfront.net";
const constants = {
    imagePath : imgPath
}
export default constants